module.exports = __webpack_public_path__ + "img/out.bc1a2c42.svg";